import axios from "axios";
import Env from "@/logics/Envs.js";

export default async function (email) {
    try {
        const toSend = new FormData();
        toSend.append("userEmail", email);
        const res = await axios.post(Env.freePath + "resetPassword", toSend);
        return res.data.error;
    } catch (err) {
        return err;
    }
}